import { render, staticRenderFns } from "./HeroAsideList.vue?vue&type=template&id=7b88424f&"
import script from "./HeroAsideList.vue?vue&type=script&lang=js&"
export * from "./HeroAsideList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports